import React from "react";
import Card from "src/components/Card";
import Seal from "./../images/seal.png";
import Sign from "./../images/sign.png";
import moment from "moment";
import { DEGREES, PG_DEGREES } from "../utils/constants";
function formatDate(date) {
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Function to get ordinal suffix
  const getDaySuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // 11th, 12th, 13th...
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const suffix = getDaySuffix(day);
  return `${day}<sup>${suffix}</sup> ${months[monthIndex]} - ${year}`;
}

const today = new Date();
function InternshipCompletionLetter(props) {
  const { Name, rollNo, degree, depart, collegename, startdate, enddate } =
    props?.data || {};

  const degreeLabel = [...DEGREES, ...PG_DEGREES].find(d => d.value === degree)?.label || degree;

  return (
    <div
      style={{
        height: "calc(100% - 64px)",
        overflowY: "auto",
        fontFamily: "Arial, Helvetica, sans-serif",
        fontSize: "16px",
        lineHeight: "1.35",
        color: "#333",
        padding: "20px",
      }}
    >
      <div className="container">
        <Card style={{ padding: "40px" }}>
          <p
            style={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
            }}
          >
            Academic Internship Certificate
          </p>

          <p
            style={{ textAlign: "right", marginTop: "20px" }}
            dangerouslySetInnerHTML={{
              __html: formatDate(today),
            }}
          ></p>

          <p style={{ textAlign: "center", marginTop: "30px" }}>
            To Whomsoever It May Concern
          </p>

          <p
            style={{
              textAlign: "justify",
              marginTop: "30px",
              textIndent: "50px",
              lineHeight: "1.8",
              fontSize: "16px",
            }}
          >
            This is to certify that{" "}
            <span
              style={{
                fontWeight: "bold",
                fontFamily: "Trebuchet MS, sans-serif",
                fontSize: "16px",
              }}
            >
              {Name}
            </span>
            , with{" "}
            <span
              style={{
                fontWeight: "bold",
                fontFamily: "Trebuchet MS, sans-serif",
                fontSize: "16px",
              }}
            >
              Roll no: {rollNo}
            </span>
            , pursuing his{" "}
            <span
              style={{
                fontWeight: "bold",
                fontFamily: "Trebuchet MS, sans-serif",
                fontSize: "16px",
              }}
            >
              {degreeLabel}
            </span>{" "}
            from the Department of{" "}
            <span
              style={{
                fontWeight: "bold",
                fontFamily: "Trebuchet MS, sans-serif",
                fontSize: "16px",
              }}
            >
              {depart}
            </span>
            ,{" "}
            <span
              style={{
                fontWeight: "bold",
                fontFamily: "Trebuchet MS, sans-serif",
                fontSize: "16px",
              }}
            >
              {collegename}
            </span>
            , has completed his internship in our organization from{" "}
            <span
              style={{
                fontWeight: "bold",
                fontFamily: "Trebuchet MS, sans-serif",
                fontSize: "16px",
              }}
            >
              {moment(new Date(startdate)).format("DD-MMM-YYYY")}
            </span>{" "}
            to{" "}
            <span
              style={{
                fontWeight: "bold",
                fontFamily: "Trebuchet MS, sans-serif",
                fontSize: "16px",
              }}
            >
              {moment(new Date(enddate)).format("DD-MMM-YYYY")}
            </span>
            . He had completed the Internship satisfactorily under my guidance.
          </p>

          <p style={{ marginTop: "10px" }}>
            We wish him all success in his future endeavours.
          </p>

          <p style={{ marginTop: "20px", marginBottom: "0px" }}>
            Yours sincerely,
          </p>
          <p style={{ margin: "0px" }}>D-Aces India Private Limited</p>

          <div style={{ marginTop: "10px", height: "80px" }}>
            {/* <img src={Sign} alt="Signature" style={{ height: '60px' }} /> */}
          </div>

          <p style={{ marginTop: "5px", marginBottom: "0px" }}>
            Venkata Rangarajan
          </p>
          <p style={{ margin: "0px" }}>Director & Head of India Operations</p>

          {/* <div style={{ marginTop: '30px' }}>
                        <img src={Seal} alt="Company Seal" style={{ height: '80px' }} />
                    </div> */}
        </Card>
      </div>
    </div>
  );
}

export default InternshipCompletionLetter;
